export default {
  zh: {
    subscription: '订阅信息',
    noSubscription: '您还没有订阅服务，赶紧 ',
    goToSubscription: '前往订阅',
    modalParticle: ' 吧',
    cancelSubscription: '取消订阅',
    paymentMethod: '支付方式：',
    subscriptionPackage: '订阅套餐：',
    declaration: '订阅声明：',
    declarationList: [
      '可随时取消连续订阅服务，取消后不再自动续费。',
      '连续订阅服务暂只支持 PayPal、信用卡支付方式。'
    ],
    itunesSubscribe: '您已在iTunes上订阅服务'
  },
  en: {
    subscription: 'Subscription Information',
    noSubscription: 'No Subscription? ',
    goToSubscription: 'Subscribe',
    modalParticle: ' Now',
    cancelSubscription: 'Unsubscribe',
    paymentMethod: 'Payment Method: ',
    subscriptionPackage: 'Subscription Plan: ',
    declaration: 'Subscription Declaration: ',
    declarationList: [
      'Recurring subscription service can be canceled at any time, and will not renew automatically once you have canceled it.',
      'The recurring subscription service only supports PayPal and Credit Card payment methods.'
    ],
    itunesSubscribe: 'You have subscribed our service on iTunes'
  }
}



// WEBPACK FOOTER //
// ./src/components/account/subscription/lang.js